/*
 * ---------------------------------------------------------------------
 * Poll Action Types
 * ---------------------------------------------------------------------
 */
export const SET_PLAZZ_POLL_PARTICIPATED = "SET_PLAZZ_POLL_PARTICIPATED";
export const SET_PLAZZ_ACTIVE_POLL = "SET_PLAZZ_ACTIVE_POLL";
export const SET_PLAZZ_VOTING = "SET_PLAZZ_VOTING";
